import styles from "./RequestScoreModal.module.css";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "antd";
import useNotification from "../../../../../../hooks/useNotification";
import EnterpriseServices from "../../../../../../services/EnterpriseServices";
import ATSServices from "../../../../../../services/ATSServices";

const RequestScoreModal = ({ isOpen, onCancel, onSubmit, data = [] }) => {
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();

  const handleOk = () => {
    onCancel(false);
  };
  const handleCancel = () => {
    onCancel(false);
  };

  const handleButtonClick = async () => {
    try {
      setLoading(true);
      const payloadCandidates = data.map((item) => ({
        enterpriseID: item?.enterpriseData?._id,
        applicationID: item?._id,
        score: "requested",
        firstName: item?.candidateData?.firstName,
        emailAddress: item?.candidateData?.emailAddress,
      }));

      const payloadScore = {
        enterpriseId: payloadCandidates?.[0].enterpriseID,
        applicants: payloadCandidates,
      };
      const res = await ATSServices.RequestScore(payloadScore);
      if (res.statusCode === 1) {
        onSubmit();
        onCancel(false);
        showNotification("IndexScore requested Successfully");
        setLoading(false);
      } else {
        handleError(`${res.statusDesc}`);
      }
    } catch (error) {
      console.error("Error while requesting scores:", error);
      if (error.statusCode === 0) {
        console.log("Error while updating info", error);
        handleError(error.description);
      } else {
        handleError("Error: Request not sent.");
      }
    }
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  return (
    <>
      <Modal
        title="SCORING"
        open={isOpen}
        footer={false}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className={styles.content_wrap}>
          <div className={styles.title}>
            You’ve selected <strong>{data.length}</strong> candidates to score
          </div>
          <div className={styles.sub_text}>
            Approximate cost: $139.50 per candidate
          </div>

          <Button
            className={styles.submit_btn}
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={data.length === 0}
          >
            Score Candidates
          </Button>

          <div className={styles.sub_line}>Learn about our cost & pricing</div>
          <div className={styles.info_box}>
            All your login details are stored in your browser, you are able to
            remove any connected app or API with in your API tab
          </div>
        </div>
      </Modal>
    </>
  );
};
export default RequestScoreModal;
